import BaseModel from "./BaseModel";

class StatusModel extends BaseModel {
  organization: string = "";
  organizationName: string = "";
  hasPreliminaryReport: boolean = false;
  hasReport: boolean = false;
  reportType: "draft" | "edit" | "current" = "draft";
  hasReportUrl: boolean = false;
  hasOrganizationReportUrl: boolean = false;
  hasOrganizationList: number = 0;

  constructor(options?: object) {
    super(options);
    this.setData(options);
  }
}

export default StatusModel;
